const HUBSPOT_UTK_COOKIE = 'hubspotutk'

export function readHubspotUtk(cookieSource?: string): string {
  const source = cookieSource ?? (typeof document === 'undefined' ? '' : document.cookie)
  if (!source) {
    return ''
  }
  const match = source.match(new RegExp(`(?:^|;\\s*)${HUBSPOT_UTK_COOKIE}=([^;]*)`))
  if (!match?.[1]) {
    return ''
  }
  const raw = match[1].trim()
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}
